import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ConfirmDialogService } from "app/core/confirm-dialog.service";
import { CoreService } from "app/core/core.service";
import { StorageService } from "app/shared/services/storage.service";
import { Subscription, switchMap, tap } from "rxjs";
import {
  IBatchMode,
  RequestInBatchService,
  UpdateInBatchEnum,
} from "../shared/services/request-in-batch.service";
import { RequestService } from "../shared/services/request.service";

@Component({
  selector: "app-header-in-batch",
  templateUrl: "./header-in-batch.component.html",
  styleUrls: ["./header-in-batch.component.scss"],
})
export class HeaderInBatchComponent implements OnInit, OnDestroy {
  public batchMode: IBatchMode;
  public buttonLabel: string;
  private subscriptions = new Subscription();

  constructor(
    private requestInBatchService: RequestInBatchService,
    public router: Router,
    private confirmDialogService: ConfirmDialogService,
    private coreService: CoreService,
    private requestService: RequestService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {
    this.requestInBatchService.batchMode$.subscribe((batchMode: IBatchMode) => {
      this.batchMode = batchMode;
      this.setButtonLabel(batchMode.updateType);
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public desactivateBatchMode() {
    this.requestInBatchService.desactivateBatchMode();
  }

  public countSelectedRequests() {
    return this.requestInBatchService.countSelectedRequestsInBatch();
  }

  public takeAction() {
    if (this.countSelectedRequests() > 0) {
      if (this.batchMode.updateType === UpdateInBatchEnum.cancelTakeInCharge) {
        this.cancelTakeInCharge();
      } else {
        void this.router.navigate(["summary-in-batch"]);
      }
    }
  }

  private setButtonLabel(updateType: UpdateInBatchEnum) {
    switch (updateType) {
      case UpdateInBatchEnum.takeInCharge:
        this.buttonLabel = "components.editRequest.takeInCharge";
        break;
      case UpdateInBatchEnum.updateResponsible:
        this.buttonLabel = "components.requestInBatch.updateResponsible";
        break;
      case UpdateInBatchEnum.updateActivity:
        this.buttonLabel = "components.requestInBatch.updateActivity";
        break;
      case UpdateInBatchEnum.cancelTakeInCharge:
        this.buttonLabel = "components.requestInBatch.cancelTakeInCharge";
        break;
      case UpdateInBatchEnum.closeWorkorder:
        this.buttonLabel = "components.requestInBatch.closeWorkorder";
        break;
      default:
        break;
    }
  }

  private cancelTakeInCharge() {
    this.confirmDialogService.createConfirmDialog({
      confirmedCB: () => {
        this.coreService.startSpinner();
        const requestInBatchIds = this.requestInBatchService
          .getSelectedRequestsInBatch()
          .map((request) => request.id);
        this.subscriptions.add(
          this.requestService
            .cancelTakeInCharge(requestInBatchIds)
            .pipe(
              switchMap(() => this.requestService.getGeojsonObservable()),
              tap(() => {
                this.storageService.notifyComponents();
                this.storageService.notifyMap();
                this.storageService.notifyList();
              }),
            )
            .subscribe(() => {
              this.requestInBatchService.desactivateBatchMode();
              void this.router.navigate(["list"]);
            }),
        );
      },
      bodyMessage:
        "components.confirmDialogComponent.cancelTakeInChargeMessage",
    });
  }
}
